import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '@/locales/en.json';
import ha from '@/locales/ha.json';
import yo from '@/locales/yo.json';
import ig from '@/locales/ig.json';
import fr from '@/locales/fr.json';
import ar from '@/locales/ar.json';

export const SUPPORTED_LANGUAGES = ['en', 'ha', 'yo', 'ig', 'fr', 'ar'];
export const RTL_LANGUAGES = new Set(['ar']);

// Pull the language off the persisted user record first, then fall back to
// i18next-browser-languagedetector's own chain (localStorage 'i18nextLng',
// then navigator).
function initialLanguage() {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.language && SUPPORTED_LANGUAGES.includes(parsed.language)) {
        return parsed.language;
      }
    }
  } catch {
    // localStorage may be unavailable (private mode); fall through to detector.
  }
  return undefined;
}

export function applyDocumentLanguage(lng) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.has(lng) ? 'rtl' : 'ltr';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ha: { translation: ha },
      yo: { translation: yo },
      ig: { translation: ig },
      fr: { translation: fr },
      ar: { translation: ar },
    },
    lng: initialLanguage(),
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

applyDocumentLanguage(i18n.language);
i18n.on('languageChanged', applyDocumentLanguage);

export default i18n;
